<!-- 查询注册用户绑定车辆接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN1234",
                "carNo": "粤A12345",
                "phone": "19912345678",
            },
            responseCode: {
                "data": {
                "merchantCode":"131",
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,查询指定车场指定车牌支付可用优惠券列表",
                t_url: this.commonUrls.test+"getParkingPayCouponList",
                p_url: this.commonUrls.prod+"getParkingPayCouponList",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '用户手机号码，用于指定城市运营券' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCouponList', info2: '是', info3: 'JSONArray', info4: '商家券列表' },
                        { info1: 'cityOperationCouponList', info2: '是', info3: 'JSONArray', info4: '城市运营券列表' },
                        ]
                },{
                    titleName: 'traderCouponList 或 cityOperationCouponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponOrigin', info2: '是', info3: 'Integer', info4: '优惠来源，0停车场 1智慧停车 2第三方定义优惠' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '与临停缴费上报中的couponType相同。优惠类型：具体对应优惠来源（couponOrigin）所对应的类型, 停车场类型：0本地优惠 1电子券优惠 2vems计费系数 3停车场线上活动优惠，智慧停车类型：1城市运营券优惠 2城市运营积分，第三方类型（针对智慧停车开放平台）：0第三方积分 2第三方优惠（缴费带券） 3第三方优惠' },
                        { info1: 'reliefType', info2: '是', info3: 'String', info4: '减免类型，券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠券名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券编码' },
                        { info1: 'faceValue', info2: '是', info3: 'Decimal', info4: '券面值' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '开始有效期，格式：yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '结束有效期， 格式：yyyyMMddHHmmss' },
                        { info1: 'isCover', info2: '是', info3: 'Integer', info4: '是否支持叠加， 0否，1是' },
                        { info1: 'maxCover', info2: '是', info3: 'Integer', info4: '最大叠加数量' },
                        { info1: 'couponTemplateCode', info2: '否', info3: 'String', info4: '券模板编码' },
                        { info1: 'useRuleFrom', info2: '否', info3: 'Decimal', info4: '可用车费金额最小值' },
                        { info1: 'useRuleTo', info2: '否', info3: 'Decimal', info4: '可用车费金额最大值' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getParkingPayCouponList.vue